//import store from '@/store'
//import router from '@/router'
//import { Buffer } from 'buffer';
//import { RepositoryFactory } from "@/repositories/RepositoryFactory";
//import AllocateMarker from '@/views/AllocateMarker/AllocateMarker';

//const UserRepository = RepositoryFactory.get("user");

const funcs = {

    currentYear() {
        const d = new Date();
        return parseInt(d.getFullYear());
    },

    // dateToUnixUTCDayRange converts a given YYYY-MM-DD date into two unix utc timestamps
    // that spans from the start of the given day, up until the end of the given day
    dateToUnixUTCDayRange(date) {
		let range = {
			startTime: null,
			endTime: null
		};
        let d = new Date(date);
        d.setUTCHours(0, 0, 0, 0);
        range.startTime = Math.floor(d.getTime() / 1000);
        d.setUTCHours(23, 59, 59, 999);
        range.endTime = Math.floor(d.getTime() / 1000);
        //alert(startOfDay);
        return range;
    },

    utcTimestampToDate(timestamp) {
        let date = new Date(timestamp * 1000);
        return date.toLocaleDateString(); 
    }

}
export default funcs